import React from 'react';

const Vue_created = () => {
  return (
    <div>
      <h1>Vue_created Component</h1>
      <p>This is the Vue_created tutorial page.</p>
    </div>
  );
}

export default Vue_created;
